export default defineNuxtPlugin((nuxtApp) => {
  const appConfig = useAppConfig();

  const cssVarStyles = useState("cssVarStyles", () => ({}));
  const applyColors = (colors) => {
    Object.entries(colors).forEach(([key, value]) => {
      const cssVarName = `--${key.replace(/([A-Z])/g, "-$1").toLowerCase()}`;
      if (import.meta.client) {
        const root = document.documentElement;
        root.style.setProperty(cssVarName, value);
      }
      cssVarStyles.value[cssVarName] = value;
    });
  };

  watch(() => appConfig, (newConfig) => {
    applyColors(newConfig?.appearance?.colorSchema);
  }, { immediate: true, deep: true });
});
